import { useEffect, useState } from "react";
import { useApi } from "../../api";
import { PageHeader } from "../GenericPage";
import { n2 } from "../../lib/format";
import { Notice } from "../../lib/ui";

/* Balance sheet as at a date – port of callBalancesheet.php (API: /api/reports/balance-sheet). Net income is carried into equity. */

export default function BalanceSheet() {
  const api = useApi();
  const [d, setD] = useState(null);
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [error, setError] = useState(null);
  useEffect(() => { api.get("/api/reports/balance-sheet", { date }).then(setD).catch((e) => setError(e.message)); }, [api, date]);
  const Section = ({ title, rows, paren }) => (<>
    <tr className="fs-sec"><td colSpan={2}>{title}</td></tr>
    {rows.length === 0 && <tr><td colSpan={2} style={{ color: "var(--muted)" }}>None</td></tr>}
    {rows.map((r) => <tr key={r.number}><td><span className="mono" style={{ color: "var(--muted)", marginRight: ".6rem" }}>{r.number}</span>{r.name}</td>
      <td className="num mono">{paren ? `(${n2(r.balance)})` : n2(r.balance)}</td></tr>)}
  </>);
  const Total = ({ label, v, strong }) => <tr className={`fs-total ${strong ? "strong" : ""}`}><td>{label}</td><td className="num mono">{n2(v)}</td></tr>;
  return (
    <main className="pg" style={{ maxWidth: "56rem" }}>
      <PageHeader slug="callBalancesheet" actions={<><input type="date" aria-label="As at" value={date} onChange={(e) => setDate(e.target.value)} />
        <button type="button" className="btn" onClick={() => window.print()}><i className="fas fa-print" /> Print</button></>} />
      <Notice notice={error && { tone: "err", text: error }} />
      {d && (
        <section className="panel fs">
          <div className="fs-head"><h2>AE2C Enterprise</h2><p>Balance sheet as at {new Date(d.date + "T00:00:00").toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })}</p></div>
          <table className="tbl"><tbody>
            <Section title="Assets" rows={d.groups.Asset} /><Total label="Total assets" v={d.totals.Asset} />
            {d.groups["Contra Asset"].length > 0 && <><Section title="Less: contra assets" rows={d.groups["Contra Asset"]} paren /><Total label="Total contra assets" v={d.totals["Contra Asset"]} /></>}
            <Total label="Net assets" v={d.net_assets} strong />
            <Section title="Liabilities" rows={d.groups.Liability} /><Total label="Total liabilities" v={d.totals.Liability} />
            <Section title="Equity" rows={d.groups.Equity} />
            <tr><td>Net income (revenue {n2(d.totals.Revenue)} − expenses {n2(d.totals.Expense)})</td><td className="num mono">{n2(d.net_income)}</td></tr>
            <Total label="Total equity" v={d.equity_final} />
            <Total label="Total liabilities + equity" v={d.liabilities_equity} strong />
          </tbody></table>
          <div className={`fs-status ${d.balanced ? "ok" : "err"}`}><i className={`fas ${d.balanced ? "fa-circle-check" : "fa-triangle-exclamation"}`} />
            {d.balanced ? " Balance sheet is balanced" : ` Unbalanced: assets differ from liabilities + equity by ${n2(d.net_assets - d.liabilities_equity)}`}</div>
        </section>
      )}
    </main>
  );
}
